import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { GoPencil } from "react-icons/go";
import { useApiRequestMutation } from "../../services/apiService";
import Swal from "sweetalert2";
import UserDrawer from "./userDrawer";
import { IoArrowBack } from "react-icons/io5";
const UserDetail = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.userId;

  const [apiRequest] = useApiRequestMutation();
  const [user, setUser] = useState(null);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerMode, setDrawerMode] = useState("edit");

  // redirect if no id
  useEffect(() => {
    if (!userId) {
      navigate("/user/list");
    }
  }, [userId, navigate]);

  // API call
  const getUserDetails = async () => {
    try {
      const res = await apiRequest({
        url: "/admin/getUserById",
        method: "POST",
        data: {
          id: userId
        }
      }).unwrap();

      console.log("user detail response", res);

      if (res?.success) {
        setUser(res.data);
      }

    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  useEffect(() => {
    if (userId) {
      getUserDetails();
    }
  }, [userId]);

  if (!user) {
    return <div className="text-center mt-5">Loading...</div>;
  }
  const formatCreatedAt = (dateString, createdBy) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const formattedDate = date.toLocaleString("en-IN", {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${createdBy} ${formattedDate}`;
  };
  const handleUserAction = async (action) => {

    const userName = `${user.first_name || ""} ${user.last_name || ""}`.trim();
    const userEmail = user.email;

    let title = "";
    let html = "";
    let confirmButtonText = "";

    if (action === "reinvite") {
      title = "Resend Invitation?";
      html = `An invitation email will be resent to <b>${userEmail}</b> so the user can activate their account.`;
      confirmButtonText = "Resend Invitation";
    }

    if (action === "deactivate") {
      title = "Deactivate User Account?";
      html = `<b>${userName} (${userEmail})</b><br/><br/>
    will no longer be able to sign in or access the system until the account is reactivated.`;
      confirmButtonText = "Deactivate User";
    }

    if (action === "activate") {
      title = "Activate User Account?";
      html = `<b>${userName} (${userEmail})</b><br/><br/>
    will regain access to the system.`;
      confirmButtonText = "Activate User";
    }

    // if (action === "deleted") {
    //   title = "Delete User Permanently?";
    //   html = `<b>${userName} (${userEmail})</b><br/><br/>
    // will be permanently removed from the system.<br/><br/>
    // <b>This action cannot be undone.</b>`;
    //   confirmButtonText = "Delete User";
    // }
    if (action === "deleted") {
      title = "Temporarily Delete User?";
      html = `<b>${userName} (${userEmail})</b><br/><br/>
    will be temporarily deleted.<br/><br/>
    You can reactivate this user anytime from the <b>User Details</b> page.`;
      confirmButtonText = "Delete User";
    }

    const result = await Swal.fire({
      title,
      html,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: action === "deleted" ? "#dc3545" : "#0782D5",
      cancelButtonColor: "#6c757d",
      confirmButtonText,
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false
    });

    if (!result.isConfirmed) return;

    try {
      // 🔹 Loader popup
      Swal.fire({
        title: "Processing...",
        text: "Please wait while we complete your request.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      let res;

      // Reinvite API
      if (action === "reinvite") {
        res = await apiRequest({
          url: "/admin/reInviteLink",
          method: "POST",
          data: { id: user.id }
        }).unwrap();
      }

      // Status Update APIs
      if (action === "activate" || action === "deactivate" || action === "deleted") {

        let newStatus = "";

        if (action === "activate") newStatus = "active";
        if (action === "deactivate") newStatus = "inactive";
        if (action === "deleted") newStatus = "deleted";

        res = await apiRequest({
          url: "/admin/updateStatus",
          method: "POST",
          data: {
            id: user.id,
            status: newStatus
          }
        }).unwrap();
        getUserDetails();
      }
      Swal.close(); // close loader
      if (res?.success) {


        const successResult = await Swal.fire({
          icon: "success",
          title: "Success",
          text: res.message,
          showConfirmButton: true, confirmButtonText: 'Ok',
          allowOutsideClick: false,
          allowEscapeKey: false
        });

        if (successResult.isConfirmed) {
          if (action === "deleted") {
            // navigate to user list page
            navigate("/user/list");
          }
        }


      }

    } catch (error) {
      Swal.close(); // close loader
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.data?.message || "Something went wrong",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: true
      });

    }

  };
  const status = user.employee_status;
  console.log('status', status)
  const handleOpenEditDrawer = () => {
    setDrawerMode("edit");
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleSave = () => {
    setIsDrawerOpen(false);
    getUserDetails(); // refresh after update
  };

  const mappedUserData = user
    ? {
      id: user.id,
      employeeId: user.employee_id,
      dateOfJoining: user.date_of_joining,
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      role: user.primaryRole?.role_name,
      secondary_role: user.secondaryRole?.role_name,
      reported_by: user.reported_by,
      status: user.employee_status,
      campaign_id: user.campaign_id,
      department_id: user.department_id,
      department_name: user.department_name
    }
    : null;
  return (
    <div>

      <div className="page-header">
        <div className="page-header-left d-flex align-items-center">
          <ul className="breadcrumb mb-0">
            <li className="breadcrumb-item">User Management</li>
            <li className="breadcrumb-item">User</li>
            <li className="breadcrumb-item active">
              {user.first_name} {user.last_name}
            </li>
          </ul>
        </div>
      </div>

      <div className="main-content">
        <div className="row">
          <div className="p-6">

            {/* <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                
                <h3 className="h4 mb-1 drawer-header">User Management</h3>
                <p className="mb-0 text-muted">View User Details.</p>
              </div>
            </div> */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center gap-3">

                {/* Rounded Back Button */}
                <div
                  onClick={() => navigate("/user/list")}
                  className="back-btn d-flex align-items-center justify-content-center"
                >
                  <IoArrowBack size={16} />
                </div>

                {/* Title + Subtitle */}
                <div>
                  <h3 className="h4 mb-1 drawer-header">User Management</h3>
                  <p className="mb-0 text-muted">View User Details.</p>
                </div>

              </div>
            </div>

            <div className="card p-3 mb-4 border-0 shadow-sm">
              {/* Toolbar */}

              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mb-1">

                <ul className="nav pl-2">
                  <li className="nav-item">
                    <a className="nav-link active tab-primary" href="#">
                      Users
                    </a>
                  </li>
                </ul>
              </div>

              <div className=" p-4 border-0">

                <div className="row align-items-center mb-3">

                  <div className="col-auto">
                    <img
                      src={user.profile_pic || "/images/avatar/userprofile.jpg"}
                      className="rounded-circle"
                      width="80"
                      height="80"
                      alt="profile"
                    />
                  </div>

                  <div className="col">
                    <h5 className="mb-1 userdetails-header" >
                      {`${user.first_name.charAt(0).toUpperCase()}${user.first_name.slice(1)} ${user.last_name.charAt(0).toUpperCase()}${user.last_name.slice(1)}`}

                      <span className="badge bg-primary ms-2">
                        {user.primaryRole?.role_displayname}
                      </span>

                      {/* <GoPencil
                        size={24}
                        style={{ cursor: "pointer", marginLeft: "8px" }}
                      /> */}
                      <GoPencil
                        size={24}
                        style={{ cursor: "pointer", marginLeft: "8px" }}
                        onClick={handleOpenEditDrawer}
                      />
                    </h5>

                    <p className="mb-0">{user.designation}</p>

                    <p className="mb-0 userdetails-color">
                      {user.employee_id} &nbsp; FLEXZ ID – {user.flexz_id}
                    </p>
                  </div>

                  <div className="col-auto d-flex align-items-center gap-2 mt-2">
                    {/* <button className="btn btn-primary rounded-3" onClick={() => handleUserAction("reinvite")}>
                      Reinvite
                    </button> */}
                    {/* Reinvite */}
                    {status === "unconfirmed" && (
                      <button
                        className="btn btn-primary rounded-3"
                        onClick={() => handleUserAction("reinvite")}
                      >
                        Reinvite
                      </button>
                    )}


                    {/* <button className="btn deactivate rounded-3" onClick={() => handleUserAction("deactivate")}>
                      Deactivate
                    </button> */}
                    {status === "active" && (
                      <button
                        className="btn deactivate rounded-3"
                        onClick={() => handleUserAction("deactivate")}
                      >
                        Deactivate
                      </button>
                    )}
                    {(status === "inactive" || status == 'deleted') && (
                      <button
                        className="btn activate rounded-3"
                        onClick={() => handleUserAction("activate")}
                      >
                        Activate
                      </button>
                    )}

                  </div>

                </div>

                <h6 class="userdetails-color">User Information</h6>


                <div className="user-info-section">

                  <div className="row info-row">
                    <div className="col-md-6">
                      <span className="info-label">First Name</span>
                      <span className="info-value">{user.first_name.charAt(0).toUpperCase()}{user.first_name.slice(1)}</span>
                    </div>

                    <div className="col-md-6">
                      <span className="info-label">Last Name</span>
                      <span className="info-value">{user.last_name.charAt(0).toUpperCase()}{user.last_name.slice(1)}</span>
                    </div>
                  </div>

                  <div className="row info-row">
                    <div className="col-md-6">
                      <span className="info-label">Email</span>
                      <span className="info-value">{user.email}</span>
                    </div>
                    <div className="col-md-6">
                      <span className="info-label">Reporting To</span>
                      <span className="info-value">{user.reported_employee_name}   <span className="badge bg-secondary ms-2">
                        {user.reported_employee_role}
                      </span>
                      </span>
                    </div>

                  </div>

                  <div className="row info-row">
                    <div className="col-md-6">
                      <span className="info-label">Primary Role</span>
                      <span className="info-value">{user.primaryRole?.role_displayname}</span>
                    </div>
                    <div className="col-md-6">
                      <span className="info-label">Secondary Role</span>
                      <span className="info-value">{user.secondaryRole?.role_displayname}</span>
                    </div>



                  </div>

                  <div className="row info-row">

                    <div className="col-md-6">
                      <span className="info-label">Date of Joining</span>
                      <span className="info-value">{user.date_of_joining}</span>
                    </div>
                    <div className="col-md-6">
                      <span className="info-label">Campaign Assignment</span>
                      <span className="info-value">
                        {user.campaign?.name || "-"}
                      </span>
                    </div>
                  </div>
                  <div className="row info-row">
                    <div className="col-md-6">
                      <span className="info-label">Added By</span>
                      <span className="info-value">
                        {formatCreatedAt(user.created_at, user.created_by)}
                      </span>
                    </div>
                    <div className="col-md-6">
                      <span className="info-label">Department</span>
                      <span className="info-value">
                        {user.department_name || "-"}
                      </span>
                    </div>
                  </div>

                </div>
                {/* 
                <h6 class="userdetails-color">Local Information</h6>

                <div className="row">

                  <div className="col-md-6">
                    <p>Language: {user.language}</p>
                    <p>Date Format: {user.date_format}</p>
                    <p>Time Zone: {user.time_zone}</p>
                  </div>

                  <div className="col-md-6">
                    <p>Country Locale: {user.country}</p>
                    <p>Time Format: {user.time_format}</p>
                  </div>

                </div> */}
                {(status != 'deleted') && (
                  <div className="d-flex justify-content-end mt-4">
                    <button className="btn btn-danger action-btn" onClick={() => handleUserAction("deleted")}>
                      Delete User
                    </button>
                  </div>
                )}

              </div>

            </div>

          </div>
        </div>
      </div>
      {isDrawerOpen && (
        <UserDrawer
          mode={drawerMode}
          userData={mappedUserData}
          onClose={handleCloseDrawer}
          onSave={handleSave}
        />
      )}
    </div>
  );
};

export default UserDetail;